import classNames from 'classnames';
import type { ReactNode } from 'react';

import '~/shared/components/tools/tools.scss';

type ToolsPropsType = {
  className?: string;
  children: ReactNode;
};

const Tools = ({ className, children }: ToolsPropsType) => (
  <div className={classNames('tools', className)}>{children}</div>
);

export default Tools;
